import { Api } from '../../../utility/client';

// TODO: Split between telesitting and mobile https://linear.app/inspiren/issue/INS-659/split-v1roomsprivacy-between-mobile-and-web-or-maybe-it-should-be-vcv1
export async function turnOffPrivacyModeForRoom(roomId: string) {
  await Api.put('/v1/rooms/privacy', { roomId, mode: 'off' });
}
